import { observable, action, runInAction, toJS } from 'mobx'
import remotedev from 'mobx-remotedev'
import { StoreExt } from '@utils/reactExt'

export class Inquiries extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable pageIndex = null
    @observable totalCount = null
    @observable currentInquiry = {}
    @observable priorityCount = 3
    @observable filters = {}

    @action
    getInquiries = async params => {
        this.loading = true
        this.api.inquiryService
            .getList({ ...params, filters: { ...toJS(this.filters), priorityCount: toJS(this.priorityCount) } })
            .then((res: any) => {
                runInAction(() => {
                    this.list = res.results
                    this.pageIndex = res.pageIndex
                    this.totalCount = res.totalCount
                    this.loading = false
                })
            })
            .catch(error => {
                throw new Error(error)
            })
    }

    @action
    getInquiry = async params => {
        this.loading = true
        this.api.inquiryService
            .getInquiry(params)
            .then((res: any) => {
                runInAction(() => {
                    this.currentInquiry = res
                    this.loading = false
                })
            })
            .catch(error => {
                this.currentInquiry = { error: 'Cant get inquiry' }
                this.loading = false
                // throw new Error(error);
            })
    }
    @action
    resetInquiry = () => {
        runInAction(() => {
            this.currentInquiry = {}
        })
    }
    @action
    updateFilters = params => {
        runInAction(() => {
            this.filters = params
        })
    }
}

export default remotedev(new Inquiries())
